/**
 * This file conatins all the chat related api endpoints
 */

import axios, { baseRequestConfig } from './base';
import { send, setMessageCallback } from './socket';

export function getChatsViaSocket(userToken, values, callback) {
  setMessageCallback(callback);
  send({
    ...baseRequestConfig(),
    user_token: userToken,
    request1: {
      request_type: 'FUNCTION',
      function_name: 'chat_msg_get',
      values: {
        detail: 'SLIM',
        limit: 25,
        ...values,
      },
    },
  });
}

export function getChats(userToken, values) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'chat_msg_get',
        values: {
          detail: 'SLIM',
          limit: 25,
          ...values,
        },
      },
    },
  });
}

export function addChatMessageViaSocket(userToken, values) {
  // socket.onmessage = callback;
  send({
    ...baseRequestConfig(),
    user_token: userToken,
    request1: {
      request_type: 'FUNCTION',
      function_name: 'chat_msg_add',
      values: {
        ...values,
      },
    },
  });
}

export function addChatMessage(userToken, values) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'chat_msg_add',
        values: {
          ...values,
        },
      },
    },
  });
}

export function chatGetUserChannels(userToken, values) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'chat_get_user_channels',
        values,
      },
    },
  });
}

export function addPrivateChatMessageViaSocket(userToken, values) {
  // socket.onmessage = callback;
  send({
    ...baseRequestConfig(),
    user_token: userToken,
    request1: {
      request_type: 'FUNCTION',
      function_name: 'chat_private_add',
      values: {
        ...values,
      },
    },
  });
}

export function getPrivateChatsViaSocket(userToken, values, callback) {
  setMessageCallback(callback);
  send({
    ...baseRequestConfig(),
    user_token: userToken,
    request1: {
      request_type: 'FUNCTION',
      function_name: 'chat_private_get',
      values: {
        detail: 'SLIM',
        limit: 25,
        ...values,
      },
    },
  });
}


export function getPrivateChatList(userToken, values) {
  return axios.request({
    method: 'post',
    data: {
      ...baseRequestConfig(),
      user_token: userToken,
      request1: {
        request_type: 'FUNCTION',
        function_name: 'chat_private_list',
        values,
      },
    },
  });
}



// WEBPACK FOOTER //
// ./src/api/chat.js